import { h, Component } from 'preact';
import { Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { AppConstant } from '../../constant/AppConstant';

class AlertModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        let self = this;
        const {t}=self.props
        let header = self.props.header ? self.props.header : t(AppConstant.ALERT);
        let buttonOk = "";
        let buttonCancel = "";
        
        if (self.props.onSubmit){
            buttonOk = <button type="button" class="btn btn-primary mx-auto btn-lg" onClick={self.props.onSubmit}>{t(AppConstant.OK)}</button>;
            buttonCancel = <button type="button" class="btn btn-secondary mx-auto btn-lg" onClick={self.props.onClose}>{t(AppConstant.CANCEL)}</button>;
        }
        else{
            buttonOk = <button type="button" class="btn btn-primary mx-auto btn-lg" onClick={self.props.onClose}>{t(AppConstant.OK)}</button>;
        }

        let modal = 
            <Modal show={self.props.open} onHide={self.props.onClose} aria-labelledby="alert-modal-title">
                    <Modal.Header closeButton>
                        <h5 class="modal-title" id="alert-modal-title">{header}</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="lead">{self.props.children}</div>
                    </Modal.Body>
                    <Modal.Footer>
                        {buttonOk}
                        {buttonCancel}
                    </Modal.Footer>
            </Modal>;

        return (
            <div>
                {modal}
            </div>
        );
    }
}

export default withTranslation()(AlertModal);